import React from 'react'
import { useIntl } from 'react-intl'
import { SECONDARY } from 'app/constants/button'
import { useGroupDialog } from '../contexts/GroupDialogContext'
import InformationDialog from 'app/componentV4/Dialog/InformationDialog'
import { DIALOG_KEYS } from '../constants'

const GroupLimitWarning = () => {
  const { formatMessage } = useIntl()
  const { dialogState, closeDialog } = useGroupDialog()
  const { open, action } = dialogState[DIALOG_KEYS.GROUP_LIMIT]

  return (
    <InformationDialog
      id="dialog-warning-limit"
      type={SECONDARY}
      open={open}
      description={action?.description}
      title={formatMessage({ id: 'text.limit.reached' })}
      onClose={() => closeDialog(DIALOG_KEYS.GROUP_LIMIT)}
      closeText="text.close"
    />
  )
}

export default GroupLimitWarning
